import { createSelector, createSlice } from '@reduxjs/toolkit';
import { removeEditStoryUrl } from '../../lib/LinkUtils.js';
import Environment from '../../StorytellerEnvironment';
import { RectObject } from '../../types';
import { StorytellerState } from 'store/StorytellerReduxState';

export type InputState = {
  text: string;
  link: string;
  openInNewWindow: boolean;
};

export type LinkTipSliceState = {
  visible: boolean;
  remove: boolean;
  inputs: InputState | null;
  boundingClientRect: RectObject | null;
  editorId: string | null;
};

const initialState: LinkTipSliceState = {
  visible: false,
  remove: false,
  inputs: null,
  boundingClientRect: null,
  editorId: null,
};

const linkTipSlice = createSlice({
  name: 'linkTipSlice',
  initialState,
  reducers: {
    openLinkTip(state, action) {
      const { payload } = action;
      payload.link = removeEditStoryUrl(payload.link, Environment.STORY_UID);
      state.visible = true;
      state.editorId = payload.editorId;

      state.inputs = {
        text: payload.text,
        link: payload.link,
        openInNewWindow: payload.openInNewWindow,
      };

      state.boundingClientRect = payload.boundingClientRect;
    },
    closeLinkTip(state) {
      state.visible = state.remove = false;
      state.inputs = state.boundingClientRect = state.editorId = null;
    },
    removeLinkTip(state) {
      state.remove = true;
    },
    acceptLinkModal(state, action) {
      const { payload } = action;
      payload.link = removeEditStoryUrl(payload.link, Environment.STORY_UID);

      state.inputs = {
        text: payload.text,
        link: payload.link,
        openInNewWindow: payload.openInNewWindow,
      };
    },
  },
});

export const linkTipSliceReducer = linkTipSlice.reducer;

export const { openLinkTip, closeLinkTip, removeLinkTip, acceptLinkModal } = linkTipSlice.actions;

export const selectLinkTipSlice = (state: StorytellerState) => state.linkTipSlice;

export const selectEditorId = createSelector(selectLinkTipSlice, (slice) => slice.editorId);

export const selectBoundingClientRect = createSelector(
  selectLinkTipSlice,
  (slice) => slice.boundingClientRect,
);

export const selectVisibility = createSelector(selectLinkTipSlice, (slice) => slice.visible);

export const selectInputs = createSelector(selectLinkTipSlice, (slice) => slice.inputs);

export const selectShouldRemoveLink = (editorId: string) =>
  createSelector(selectLinkTipSlice, (slice) => editorId === slice.editorId && slice.remove);
